import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";   
import Home from "./Pages/Home";
import ErpSoftware from "./Pages/ErpSoftware";
import Events from "./Pages/Events";
import News from "./Pages/News";
import TopperX from "./Pages/TopperX";
import TopperXII from "./Pages/TopperXII";
import Gallery from "./Pages/Gallery";
import Exhibitions from "./Pages/Exhibitions";
import Activities from "./Pages/Activities";
import SubGallery from "./Pages/SubGallery"; 
import About from "./Pages/About";
import Faculty from "./Pages/Faculty";
import GeneralRules from "./Pages/GeneralRules";
import Mission from "./Pages/Mission";
import Vision from "./Pages/Vision";
import Sports from "./Pages/Sports";
import Clubs from "./Pages/Clubs";
import Supw from "./Pages/Supw";
import Withdrawal from "./Pages/Withdrawal";
import Examination from'./Pages/Examination';
import Discipline from'./Pages/Discipline';
import SchoolFee from'./Pages/SchoolFee';
import RegistrationForm from'./Pages/RegistrationForm';
import AdmissionProcess from'./Pages/AdmissionProcess';
import FeeStructure from'./Pages/FeeStructure';
import Pphelp from'./Pages/Pphelp';
import ScrollTopBtn from'./Component/ScrollTopBtn';
import AcademicEthos from'./Pages/AcademicEthos';
import Motto from'./Pages/Motto';
import VideoGallery from'./Pages/VideoGallery'; 
import Facilities from'./Pages/Facilities';
import PrincipalMessage from'./Pages/PrincipalMessage';
import Tc from'./Pages/Tc';
import GreenClub from'./Pages/GreenClub';
import EnglishLiteraryClub from'./Pages/EnglishLiteraryClub';
import MusicClub from'./Pages/MusicClub';
import PerformingArtsClub from'./Pages/PerformingArtsClub';
import QuestClub from'./Pages/QuestClub';
import PiccasoClub from'./Pages/PiccasoClub';
import RamanujanClub from'./Pages/RamanujanClub';
import { BrowserRouter, Routes, Route } from "react-router-dom"; 
function App() {
  return (
      <>
      <BrowserRouter>
      <ScrollTopBtn/> 
          <Routes>
           <Route path="/" element={<Home/>}/>
           <Route path="/ErpSoftware" element={<ErpSoftware/>}/>
           <Route path="/Events" element={<Events/>}/>
           <Route path="/News" element={<News/>}/>
           <Route path="/TopperX" element={<TopperX/>}/>
           <Route path="/TopperXII" element={<TopperXII/>}/>
           <Route path="/Gallery" element={<Gallery/>}/>
           <Route path="/Exhibitions" element={<Exhibitions/>}/>
           <Route path="/Activities" element={<Activities/>}/> 
           <Route path="/SubGallery" element={<SubGallery/>}/>
           <Route path="/Tc" element={<Tc/>}/>
           <Route path="/About" element={<About/>}/>
           <Route path="/GeneralRules" element={<GeneralRules/>}/>
           <Route path="/Mission" element={<Mission/>}/>
           <Route path="/Vision" element={<Vision/>}/>
           <Route path="/Examination" element={<Examination/>}/>
           <Route path="/Sports" element={<Sports/>}/>
           <Route path="/Clubs" element={<Clubs/>}/>
           <Route path="/Supw" element={<Supw/>}/>
          <Route path="/Withdrawal" element={<Withdrawal/>}/>
          <Route path="/SchoolFee" element={<SchoolFee/>}/>
           <Route path="/Discipline" element={<Discipline/>}/>
            <Route path="/RegistrationForm" element={<RegistrationForm/>}/>
            <Route path="/AdmissionProcess" element={<AdmissionProcess/>}/>
            <Route path="/FeeStructure" element={<FeeStructure/>}/>
           <Route path="/AcademicEthos" element={<AcademicEthos/>}/>
           <Route path="/Pphelp" element={<Pphelp/>}/>
           <Route path="/Faculty" element={<Faculty/>}/>
          <Route path="/VideoGallery" element={<VideoGallery/>}/>
           <Route path="/Motto" element={<Motto/>}/>
          <Route path="/PrincipalMessage" element={<PrincipalMessage/>}/>
           <Route path="/Facilities" element={<Facilities/>}/>
             <Route path="/EnglishLiteraryClub" element={<EnglishLiteraryClub/>}/>
             <Route path="/MusicClub" element={<MusicClub/>}/>
              <Route path="/GreenClub" element={<GreenClub/>}/>
                <Route path="/PerformingArtsClub" element={<PerformingArtsClub/>}/>
                 <Route path="/QuestClub" element={<QuestClub/>}/>
                  <Route path="/PiccasoClub" element={<PiccasoClub/>}/>
                 <Route path="/RamanujanClub" element={<RamanujanClub/>}/>
          </Routes> 
     </BrowserRouter>
      </>
  )
}

export default App;
